// src/auth/jwt.ts
export type JwtPayload = { exp?: number; [k: string]: unknown };

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const [, payload] = token.split(".");
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json) as JwtPayload;
  } catch {
    return null;
  }
}

/** Returns true if token is expired or invalid. `skewSec` adds a buffer window. */
export function isExpired(token: string, skewSec = 30): boolean {
  const p = decodeJwt(token);
  if (!p?.exp) return true;
  const now = Math.floor(Date.now() / 1000);
  return now >= p.exp - skewSec;
}

/** Seconds left until expiry (negative if already expired). */
export function secondsUntilExpiry(token: string): number {
  const p = decodeJwt(token);
  if (!p?.exp) return -1;
  const now = Math.floor(Date.now() / 1000);
  return p.exp - now;
}
